import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/index-top-bg.png';
import _imports_1 from '@/assets/rightarrow.png';
import _imports_2 from '@/assets/rightarrowactive.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7fb62cfe"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "w-100% min-w-1200px h480px pos-relative"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    "class": "w-100% h-100%"
  }, null, -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "c-top",
    "data-aos": "fade-up"
  }, "政务呼叫中心智能化解决方案专家", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "c-top-2",
    "data-aos": "fade-up",
    "data-aos-delay": "300"
  }, " 智慧政务呼叫中心全面解决方案 ", -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "c-top-3",
    "data-aos": "fade-up",
    "data-aos-delay": "600",
    innerHTML: '<span style=color:#00fcff;>九</span>大智能产品模块，支持灵活组合与现有系统无缝集成'
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "了解产品", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    "class": "h-23px"
  }, null, -1);
});
var _hoisted_8 = [_hoisted_6, _hoisted_7];
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "集成方案", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    "class": "h-23px"
  }, null, -1);
});
var _hoisted_11 = [_hoisted_9, _hoisted_10];
export default {
  __name: 'indexTop',
  emits: ['showCode'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var showCode = function showCode() {
      emit('showCode');
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("main", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
        "class": "position-box"
      }, [_hoisted_3, _hoisted_4, _hoisted_5, _createElementVNode("div", {
        "class": "flex justify-between mt-73px"
      }, [_createElementVNode("button", {
        "data-aos": "fade-right",
        "data-aos-delay": "800",
        "class": "c-top-btn left-btn",
        onClick: showCode
      }, _hoisted_8), _createElementVNode("button", {
        "data-aos": "fade-left",
        "data-aos-delay": "800",
        "class": "c-top-btn right-btn ml-89px",
        onClick: showCode
      }, _hoisted_11)])])]);
    };
  }
};